import { useAtom } from '@reatom/npm-react'

import { PlatformUtil } from '@root/shared'

import { selectedNetworkAtom } from '../atoms'
import { Network } from '../model'

import type { Address } from '@root/entities/address/Address'
import type { TxHash } from '@root/entities/transaction'

export const useNetworkLinks = (options?: { network?: Network.Network }) => {
  const [selectedNetwork] = useAtom(selectedNetworkAtom)

  const resolvedNetwork = options?.network ?? selectedNetwork

  const openTransactionExplorerLink = (hash: TxHash) => {
    const link = Network.makeExplorerTransactionLink(resolvedNetwork, hash)
    return PlatformUtil.openLink(link, '_blank')
  }

  const buildTransactionExplorerLink = (hash: TxHash) =>
    Network.makeExplorerTransactionLink(resolvedNetwork, hash)

  const buildContractLink = (hash: Address) =>
    Network.makeExplorerContractLink(resolvedNetwork, hash)

  return {
    openTransactionExplorerLink,
    buildTransactionExplorerLink,
    buildContractLink,
  }
}
